<template>
    <v-dialog max-width="500px" v-model="show" dark>
        <v-card class="hacker-dialog">
            <v-card-title class="headline">Spoof</v-card-title>
            <v-card-text>
                Spoofing a message lets you send your own message but make it look like someone else has sent it.
            </v-card-text>
            <v-card-text>
                Spoofing a text message or email will create a messaging thread that you can then continue with your spoofed name and role through the email or messaging app.
            </v-card-text>
            <v-card-text>
                <v-select v-model="type" :items="messageTypes" label="Message Type" outlined item-text="name" item-value="id"></v-select>
                <v-text-field v-model="spoofName" label="Spoof Name" outlined hint="This is the name that this message will be shown to come from."></v-text-field>
                <v-text-field v-model="spoofRole" label="Spoof Role" outlined hint="This is the role that will be shown next to the name of the person sending the message. This may be left blank for no role."></v-text-field>
                <!-- <v-select v-model="spoof" :items="players" label="Spoofed Sender" outlined :item-text="playerString" item-value="id" return-object></v-select> -->
                <v-select v-if="recipientNeeded" v-model="recipient" :items="players" label="Recipient" outlined :item-text="playerString" item-value="id" return-object></v-select>
                <v-text-field v-if="subjectNeeded" v-model="subject" label="Subject" outlined></v-text-field>
                <v-textarea v-model="message" label="Message" outlined></v-textarea>
            </v-card-text>
            <v-card-text>
                <v-alert type="info">
                    {{ alertMessage }}
                </v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click.stop="close()">Cancel</v-btn>
                <v-btn color="primary" text @click.stop="send()">Send</v-btn>
            </v-card-actions>

            <v-snackbar v-model="snackbar" color="error">
                {{ snackbarMessage }}
                <v-btn text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        value: Boolean,
        action: Object
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit("input", value);
            }
        },
        alertMessage() {
            var output = "";
            if (this.type == "social") {
                output = "Your message will be shown to all players through the SoMed app.";
            } else if (this.type == "text" && this.recipient) {
                output = `Your message will be shown to '${this.playerString(this.recipient, false)}' through the messaging app.`;
            } else if (this.type == "email" && this.recipient) {
                output = `Your message will be shown to '${this.playerString(this.recipient, false)}' through the email app.`;
            } else {
                output = "Your message will not be shown to any players.";
            }

            if (this.spoofName) {
                var name = this.spoofName;
                if (this.spoofRole) {
                    name += ` (${this.spoofRole})`;
                }
                output += ` Your message will be shown to be sent by '${name}'.`;
            }

            if (this.recipient) {
                output += ` Your message will be sent to '${this.playerString(this.recipient, false)}'.`;
            }

            return output;
        },
        recipientNeeded() {
            return this.type != "social";
        },
        subjectNeeded() {
            return this.type == "email";
        },
        ...mapState([
            "players"
        ])
    },
    data: () => ({
        spoofName: "",
        spoofRole: "",
        recipient: null,
        message: "",
        messageTypes: [{
            id: "social",
            name: "Social Media"
        },
        {
            id: "text",
            name: "Text Message"
        },
        {
            id: "email",
            name: "Email"
        }],
        type: "social",
        snackbar: false,
        snackbarMessage: "",
        subject: ""
    }),
    methods: {
        showSnackbar(message) {
            this.snackbar = true;
            this.snackbarMessage = message;
        },
        playerString(player, showCode = true) {
            if (showCode) {
                return `${player.name} (${player.participant_code})`;
            }
            return `${player.name}`;
        },
        send() {
            // Check for a recipient
            if (this.recipientNeeded && !this.recipient) {
                this.showSnackbar("You need to select a recipient before sending");
                return;
            }

            this.spoofName = this.spoofName.trim();
            this.spoofRole = this.spoofRole.trim();

            // Check for spoof
            if (!this.spoofName) {
                this.showSnackbar("You need to type someone to spoof the message as");
                return;
            }

            this.subject = this.subject.trim();

            if (this.subjectNeeded && this.subject.length <= 0) {
                this.showSnackbar("You need to type a subject before sending");
                return;
            }

            this.message = this.message.trim()
            if (this.message.length <= 0) {
                this.showSnackbar("You need to type a message before sending");
                return;
            }

            this.$socket.client.emit("send_message", {
                recipient: this.recipient?.id,
                spoofName: this.spoofName,
                spoofRole: this.spoofRole,
                content: this.message,
                type: this.type,
                subject: this.subject
            });
        },
        close() {
            this.message = "";
            this.spoofName = "";
            this.spoofRole = "";
            this.type = "social";
            this.recipient = null;
            this.show = false;
        }
    },
    sockets: {
        send_event(state) {
            if (state == "sent") {
                this.close();
            }
        }
    }
}
</script>

<style scoped>
    * {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
    }
</style>
